/* eslint-disable @next/next/no-img-element */
import classNames from 'classnames';

import { ImgHTMLAttributes } from 'react';
import styles from './image.module.scss';

export type ImageProps = {
  src: ImgHTMLAttributes<HTMLImageElement>['src'];
  alt: ImgHTMLAttributes<HTMLImageElement>['alt'];
  className?: string;
  imageClassName?: string;
  backgroundColor?: string;
  naturalHeight?: number;
  naturalWidth?: number;
  objectFit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down';
  objectPosition?: 'top' | 'bottom' | 'left' | 'right' | 'center';
  srcSet?: ImgHTMLAttributes<HTMLImageElement>['srcSet'];
  sizes?: ImgHTMLAttributes<HTMLImageElement>['sizes'];
  style?: React.CSSProperties;
  fetchPriority?: ImgHTMLAttributes<HTMLImageElement>['fetchPriority'];
  loading?: ImgHTMLAttributes<HTMLImageElement>['loading'];
};

const Image = ({
  src,
  alt,
  className,
  imageClassName,
  backgroundColor,
  naturalHeight,
  naturalWidth,
  objectFit,
  objectPosition,
  loading = 'lazy',
  srcSet,
  sizes,
  style,
  fetchPriority = 'low',
}: ImageProps) => {
  const aspectRatio =
    naturalWidth && naturalHeight
      ? `${naturalWidth} / ${naturalHeight}`
      : undefined;

  return (
    <div
      className={classNames('image-wrapper', styles.wrapper, className)}
      style={{ backgroundColor, ...style }}
    >
      <img
        className={classNames(styles.image, imageClassName)}
        fetchPriority={fetchPriority}
        src={src}
        alt={alt}
        srcSet={srcSet}
        sizes={sizes}
        loading={loading}
        style={{
          objectFit,
          objectPosition,
          aspectRatio,
          maxHeight: style?.maxHeight,
          maxWidth: style?.maxWidth,
          height: style?.height,
          width: style?.width,
        }}
      />
    </div>
  );
};

export default Image;
